<template>
    <div class="zalog" ref="zalogTileContent">
        <table-title>Залоги</table-title>
        <update-button
            @click.native="updateZalog"
            class="zalog__btn"
            :isLoading="isUpdating"
            :success="Number(actual) === 1"
        >
            <span v-if="!isUpdating" slot="default">Обновить информацию о залогах</span>
            <span v-if="isUpdating" slot="default">Информация обновляется. Ожидайте или попробуйте обновить страницу позже</span>
            <span slot="success">Информация о залогах актуальна.</span>
        </update-button>
        <div v-if="auth" class="zalog__content">
            <span v-if="list.length === 0" class="empty-message">Уведомления о залогах отсутствуют</span>
            <zalog-table v-if="list.length > 0" :list="renderList" :actualDate="updateDate" />
        </div>
        <demo-message v-else />
    </div>
</template>

<script>
import tableTitle from '@/components/ui/tableTitle.vue.js'
import updateButton from '@/components/ui/updateButton/updateButton.vue'
import demoMessage from '@/components/ui/demoMessage/demoMessage.vue'
import zalogTable from '@/components/card/zalogLeasing/zalog/zalogTable.vue'

export default {
    props: {
        list: Array
    },
    components: {
        tableTitle,
        updateButton,
        zalogTable,
        demoMessage
    },
    computed: {
        updateDate() { return this.$store.state.card?.zalogLeasing?.zalog?.updateDate },
        actual() {
            console.log(this.$store.state.card?.zalogLeasing?.zalog) 
            return this.$store.state.card?.zalogLeasing?.zalog?.actual},
        isUpdating() { return this.$store.state.card?.zalogLeasing?.zalog?.isUpdating },
        renderList() { return this.$props.list?.length > 4 ? this.$props.list.slice(0, 4) : this.$props.list }
    },
    methods: {
        updateZalog() { 
            this.$store.dispatch('card/zalogLeasing/updateZalog')
        }
    }
}
</script>

<style lang="sass" scoped>
.zalog
    &__btn
        margin-bottom: 15px
    .empty-message
        color: #777
        margin: 15px 0
        font-size: 16px
        line-height: 18px
        display: inline-block

</style>